/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */
export const mediaViewerPopupClass = 'media-viewer-popup';